import types from './mutation-types';
import PendingBidService from '@/services/pending-bid-service';
import { flashSuccess, flashDanger } from '@/helpers/flash-message-helper';
import ItemService from '@/services/item-service';
import { isNil } from 'lodash';
import { CancelToken } from 'axios';

let requestSource = null;

class PendingBids {

	constructor(commit, auctionId) {
		this.commit = commit;
		this.auctionId = auctionId;
	}

	fetchPendingBids(params) {
		// cancel all current requests
		if (!isNil(requestSource)) {
			requestSource.cancel();
		}

		requestSource = CancelToken.source();

		this.commit(types.FETCH_PENDING_BIDS_START);

		return PendingBidService.getAuctionPendingBids(this.auctionId, params, requestSource.token)
			.then(data => {
				this.commit(types.FETCH_PENDING_BIDS_SUCCESS, {
					pendingBids: data.data,
					meta: {
						currentPage: data.current_page,
						total: data.total,
						perPage: data.per_page,
						totalPages: this.calculateTotalPages(data.per_page, data.total)
					}
				});

			}).catch(error => this.commit(types.FETCH_PENDING_BIDS_ERROR, error.errors));
	}

	calculateTotalPages(perPage, total) {
		return Math.ceil(total / perPage);
	}
}

const actions = {
	fetchAuctionPendingBids({ commit }, { auctionId, params }) {
		return new PendingBids(commit, auctionId).fetchPendingBids(params);
	},
	deleteBid({ commit, dispatch }, { itemId, bidId }) {

		commit(types.DELETE_BID_START);

		return ItemService.deletePendingBid(itemId, bidId)
			.then(response => {
				commit(types.DELETE_BID_SUCCESS);
				flashSuccess('Bod succesvol verwijderd');
			})
			.catch(error => {
				commit(types.DELETE_BID_ERROR, error)
				flashDanger('Fout bij het verwijderen');
			});

	}
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/pending-bid-list/actions.js